import { Serializable } from './Serializable';
import { UserDTO } from './UserDTO';

export class UniverseDTO extends Serializable {

    participants: Array<UserDTO>;
    participantsTotal: number;

    guests: Array<UserDTO>;
    guestsTotal: number;

    precision: string;

    constructor() {
        super();

        this.participants = [];
        this.guests = [];
    }

}
